import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { OnePageCheckoutAccordion } from "./OnePageCheckoutAccordion";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import setIsPreloadingData from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetIsPreloadingData";
import clearMessages from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ClearMessages";
import PageProps from "@insite/client-framework/Types/PageProps";
import loadCurrentCart from "@sunSource/Store/Data/NewOnePageCheckout/Handlers/LoadCurrentCart";

const mapStateToProps = (state: ApplicationState) => {
    const currentPromotionsDataView = getCurrentPromotionsDataView(state);
    const cartState = getCurrentCartState(state);
    return {
        shouldLoadCart:
            !cartState.isLoading &&
            (!cartState.value || (cartState.value.lineCount && !cartState.value.cartLines?.length)),
        shouldLoadPromotions: !currentPromotionsDataView.value && !currentPromotionsDataView.isLoading,
        isPreloadingData: state.pages.checkoutShipping.isPreloadingData,
    };
};

const mapDispatchToProps = {
    loadCurrentCart,
    setIsPreloadingData,
    clearMessages,
};

type Props = PageProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface OnePageCheckoutPageContainerStyles {
    container?: GridContainerProps;
    leftGridItem?: GridItemProps;
    spaceGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
}

export const containerStyles: OnePageCheckoutPageContainerStyles = {
    container: {
        css: css`
        margin-bottom: 30px;
        `
    },
    leftGridItem: {
        width: [12, 12, 8, 8, 8],
        css: css`
            padding-right: 30px;
            border-right: 2px solid #D3D3D3;
            & > div > div:not(:last-child) {
           
                border-bottom: 1px solid ${getColor("common.border")};
            }
        `,
    },
    rightGridItem: { width: [12, 12, 4, 4, 4],
         css: css`
         padding-left: 30px;
         `
     },
};

const styles = containerStyles;

const NewOnePageCheckoutPageContainer = ({ id ,  shouldLoadCart,
    shouldLoadPromotions,
    isPreloadingData,
    setIsPreloadingData,
    loadCurrentCart,
    clearMessages,}: Props) => {
     useEffect(() => {
            if (shouldLoadCart) {
                loadCurrentCart({ getPromotions: true });
            }
    
            if (!shouldLoadPromotions && !shouldLoadCart && isPreloadingData) {
                setIsPreloadingData({ isPreloadingData: false });
            }
        },[]);
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftGridItem}>
                <Zone zoneName="Content0" contentId={id} />
            </GridItem>
            <GridItem {...styles.rightGridItem}>
                <Zone zoneName="Content1" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NewOnePageCheckoutPageContainer),
    definition: {
        displayName: "New One Page Container",
        group: "One Page Checkout",
        // allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;

export const CartPageContext = "NewOnePageCheckout";


